<template>
  <div id="bid-info">
    <el-row>
      <el-col :span="16">
        <div class="bid-info__title">
          <div v-if="bid.is_paid" class="title__paid">₽</div>
          <div>
            <span class="number_date" :class="carrierRequest ? 'green' : ''">
              <span>{{ getTitle }}</span>
              <span class="clickableTitle" @click="openEditModal">
                {{ getTitleClientName }}
              </span>
            </span>
            <br />
            <span v-if="!isDispatcherRole" class="number_date">
              ИСПОЛНИТЕЛЬ
              <span v-if="bid.org_performer_id">
                {{ performerName.toUpperCase() || '-' }}
              </span>
              <choose-performer
                v-else
                :id="bid.id"
                :update-id="bid.id"
                @update="updateBidData"
              >
                <span class="sh-comment">НЕ УКАЗАН</span>
              </choose-performer>
            </span>
          </div>
        </div>
      </el-col>
      <el-col :span="8" class="shipping_info_right">
        <el-row
          v-if="canAction('shipping_stat')"
          tag="p"
          type="flex"
          align="middle"
          justify="end"
          class="weight ta-r mb0"
        >
          <img
            v-if="bid.managers && bid.managers.length"
            src="@/assets/img/user-green.png"
            class="manager-icon"
            @click="$alert(bid.managers[0].fio)"
          />
          <span v-if="bid.views_count" class="count-view">
            <i class="el-icon-view" />
            {{ bid.views_count }}
          </span>
          <span>Всего: {{ bid.weight }} т.</span>
          <span v-if="!isDispatcherRole">
            , погружено: {{ bid.countAuto || 0 }} авто.
          </span>
        </el-row>
        <el-row
          tag="p"
          type="flex"
          align="middle"
          justify="end"
          class="weight ta-r m0"
        >
          <div>{{ getTypeCode }}</div>
          <span v-if="bid.require_payment" style="margin-left: 4px">
            /&nbsp;<b>Внутренняя перевозка</b>
          </span>
        </el-row>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="19" class="shipping-row">
        <div @click="$alert(bid.load_point)">
          <h2 class="d_h2">{{ loadLocationFilter(bid) }}</h2>
          <p class="ri_p1">{{ bid.load_point.split(',')[0] }}</p>
          <p v-if="loadDistrict" class="ri_p1">{{ loadDistrict }}</p>
        </div>
        <div class="sh_dist">
          <img src="@/assets/img/arrow-route.svg" />
          <p class="ri_p2">{{ bid.distance }} км</p>
        </div>
        <div>
          <h2 class="d_h2">{{ findStevedore(bid) || 'не указан' }}</h2>
          <p class="ri_p1">
            {{ bid.unload_point.split(',')[1] }}{{ showExporter ? ',' : '' }}
            <span
              class="sh-comment"
              @click="$emit('set', bid, 'dialog_choose_exporter')"
            >
              <span v-if="showExporter">{{ showExporter }}</span>
            </span>
          </p>
        </div>
      </el-col>
      <el-col :span="5">
        <h2 class="distance mt6">
          <img
            v-if="bid.show_on_landing && false"
            class="distance__img"
            src="@/assets/img/call-center-phone.png"
            alt=""
          />
          <img v-if="bid.hot" src="@/assets/img/fire.svg" alt="" />
          <template v-if="!bid.is_tudatka">
            <img src="@/assets/img/grass.svg" alt="" />
            {{ freightsType }}
          </template>
          <template v-else>
            <i class="el-icon-truck" style="color: #ff0000" />
            <span style="margin-left: 8px">ТУДАТКА</span>
          </template>
        </h2>
        <sort-btns
          v-if="canAction('sortActions')"
          :id="bid.id"
          :order="bid.order"
          :index="index"
          v-on="$listeners"
        />
      </el-col>
    </el-row>
    <el-row>
      <el-col
        v-if="bid.managers && bid.managers.length"
        :span="11"
        class="sh-span"
      >
        <b>Менеджер: </b>
        <span
          v-if="canAction('shipping_bids_edit')"
          class="sh-comment"
          @click="$emit('set', bid, 'dialog_edit_shipping', true)"
        >
          {{ bid.managers[0].fio }}
        </span>
        <span v-else>{{ bid.managers[0].fio }}</span>
      </el-col>
      <el-col
        v-if="bid.comment || bid.private_comment"
        :span="11"
        class="sh-span"
      >
        <span
          class="sh-comment"
          @click="showComment(bid.comment, bid.private_comment, bid.id)"
        >
          Показать комментарий
        </span>
      </el-col>
    </el-row>
    <div>
      <template v-if="!isCollapse" style="display: flex; align-items: center">
        <short-day-info
          v-for="day in bid['load_days']"
          :key="day.id"
          :day="day"
          :type="bid['type_code']"
        />
      </template>
    </div>

    <client-settings-modal
      :visible="isEditClientOpen"
      :client="client"
      @close="closeEditModal"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { typeCodes } from '@/datas/consts'
import ChoosePerformer from '@/components/Modals/ChoosePerformer'
import ClientSettingsModal from '@/views/ClientsSettings/components/ClientSettingsModal.vue'
import ShortDayInfo from './ShortDayInfo'
import SortBtns from './SortBtns'
import shippingMixin from '@/mixins/shippingMixin'

export default {
  name: 'BidInfo',
  components: { ShortDayInfo, SortBtns, ChoosePerformer, ClientSettingsModal },
  mixins: [shippingMixin],
  props: {
    bid: {
      type: Object,
      default: () => {},
    },
    isCollapse: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isEditClientOpen: false,
      client: null,
    }
  },
  computed: {
    ...mapGetters({
      getLibObj: 'libs/getLibObj',
      list: 'organizations/getExporters',
      exporterName: 'organizations/getExpShortNameById',
      getOrgById: 'organizations/getOrgById',
    }),
    performerName() {
      return this.getOrgById(this.bid.org_performer_id)
    },
    getTypeCode() {
      const type = typeCodes.find(t => t.label === this.bid.type_code)

      return type ? `Тип заявки: ${type.full || type.title}` : ''
    },
    showExporter() {
      const { unload_point, exporter_id } = this.bid

      return unload_point.split(',')[1]?.includes('Новороссийск') &&
        this.list.length &&
        this.canAction('chooseExporter')
        ? this.exporterName(exporter_id) || 'Экспортер не указан'
        : ''
    },
    freightsType() {
      return this.getLibObj('freightTypes')[this.bid.freight_id]
    },
    getTitle() {
      const { id, client_short_name, created_at } = this.bid
      let text = `Перевозка №${id}`

      text += this.carrierRequest
        ? this.carrierRequest
        : `. Дата создания ${this.dateToFormat(created_at)}`

      if (!this.isDispatcherRole) {
        text += client_short_name ? ', ' : ''
      }

      return text
    },
    getTitleClientName() {
      const { client_short_name } = this.bid

      return !this.isDispatcherRole ? client_short_name : ''
    },
    carrierRequest() {
      const { carrier_request_number: number, carrier_request_date: date } =
        this.bid

      return number && date
        ? ` по поручению №${number} от ${this.dateToFormat(
            date,
            'defaultDateRu',
          )}`
        : ''
    },
    loadDistrict() {
      return this.bid.load_point.split(',')[3]
    },
  },
  methods: {
    ...mapMutations('bids', ['updateBidData']),
    showComment(comment, private_comment, id) {
      let text = comment ? `${comment}. ` : ''

      if (private_comment) {
        text += `Телефон ответственного: ${private_comment}`
      }
      this.$alert(text, `Комментарий к перевозке №${id}`)
    },
    choosingPerformer() {
      if (!this.bid.org_performer_id) {
        this.$emit('set', this.bid, 'dialog_choosing_performer')
      }
    },
    openEditModal() {
      this.isEditClientOpen = true
      this.client = {
        description: this.bid.client_description,
        require_szvm_insurance_docs: this.bid.client_szvm_required,
        short_name: this.bid.client_short_name,
        id: this.bid.client_id,
      }
    },
    closeEditModal() {
      this.client = null
      this.isEditClientOpen = false
    },
  },
}
</script>

<style lang="sass">
#bid-info
  padding-bottom: 10px
  min-height: 150px
  .bid-info__title
    display: flex
    align-items: center
    gap: 16px
    margin-top: 12px
    margin-bottom: 8px
    .title__paid
      font-size: 26px
      font-weight: 500
      color: #00bf40
  .item
    margin-top: 10px
    margin-right: 40px
  .d_h2
    font-size: 24px
  .m0
    margin: 0
  .mb0
    margin-bottom: 0
  .mt6
    margin-top: 4px!important
  .sh-span
    font-size: 14px
  .sh-comment
    color: #409EFF
    border-bottom: 1px solid
    cursor: pointer
  .sh_dist
    display: flex
    flex-direction: column
    margin: 0 15px
    align-items: center
  .number_date
    font-size: 14px
    line-height: 17px
    color: rgba(0, 0, 0, 0.47)
    border-radius: 5px
    &.green
      color: #00bf40
  .distance
    font-size: 24px
    line-height: 17px
    color: #000000
    display: flex
    align-items: center
    justify-content: flex-end
    margin: 10px 0
    img
      margin-right: 10px
      max-width: 26px
      max-height: 26px
  .d_h2
    margin: 0
  .time
    font-size: 14px
    line-height: 17px
    color: rgba(0, 0, 0, 0.47)
    border-radius: 5px
    margin: 0 0 15px 0
    span
      margin: 0 5px
  .shipping-row
    display: flex
    align-items: center
    p
      font-size: 12px
      line-height: 17px
      &.ri_p1
        color: rgba(0, 0, 0, 0.5)
        span
          margin-left: 5px
      &.ri_p2
        color: #000000
  .shipping-h2
    margin-bottom: 0
    display: flex
    justify-content: center
  .shipping_info_right
    text-align: right
    margin-top: 10px
    .manager-icon
      width: 17px
      margin-right: 10px
      cursor: pointer
      border-radius: 50%
    .count-view
      margin-right: 10px
      &>i
        margin-right: 5px
    .weight
      font-size: 14px
      line-height: 17px
      color: rgba(0, 0, 0, 0.7)
      border-radius: 5px
.clickableTitle
  color: #409eff
  font-weight: 500
  cursor: pointer
</style>
